<template>
<div>
	<p v-if="!activeComponentIsBid"><a href="#" v-on:click.prevent="backToCats"><i class="fa fa-arrow-up"></i> Back</a></p>

	<ul class="list-group mb-2">
		<li v-for="component in componentsList"
			class="list-group-item list-group-item-action" 
			v-on:click="componentClicked(component)">

			{{ component.item_number }}: {{ component.name }}
		</li>
	</ul>
</div>
</template>
<script type="text/javascript">

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "BidComponentPicker",
	mixins: [ProjectBidMixins],
	props: [
		"bidId",
		"projectId",
		"depth"
	],
	data() {
		return {
			bid: null,
			activeComponent: null,
			activeComponentIsBid: false,
			componentsList: []
		}
	},
	watch: {
		bidId() {
			this.setBid()
		},
		projectId() {
			this.setBid()
		}
	},
	methods: {
		backToCats() {
			this.activeComponent = this.bid
			this.setComponentListFromBid()
		},
		componentClicked(component) {
			if (this.depth == 0 && this.activeComponentIsBid) {
				this.$emit('componentSelected',component)
			}
			else {
				this.fetchBidComponent(component.id).then(response => {
					this.$emit('componentSelected',response.data)
				})
			}
		},
		fetchBidComponent(id) {
			let vm = this

			let params = {
				include: ["JobBidComponent"]
			}

			vm.spinner(true)

			return new Promise ((resolve,reject) => {

				vm.getJSON("JobBidComponent/find/"+id,params).then(response => {
					if (response.success) {
						vm.activeComponent = response.data
						vm.activeComponentIsBid = false
						vm.componentsList = vm.activeComponent.JobBidComponent
					}

					resolve(response)

					vm.spinner(false)
				})
			})
		},
		setComponentListFromBid() {
			this.activeComponentIsBid = true

			this.componentsList = this.bid.JobBidComponent.filter(comp => comp.bid_component_id == 0)

		},
		setBid() {
			let vm = this

			if (this.bidId) {

				let params = {
					include: ["JobBidComponent"]
				}

				this.getJSON("JobBid/find/" + this.bidId,params).then(response => {
					if (response.success) {
						vm.bid = response.data

						vm.activeComponent = response.data
						vm.setComponentListFromBid()
						vm.$emit("bidSet",vm.bid)
					}
				})
			}
			else if (this.projectId) {
				let options = {
					projectId: this.projectId
				}

				this.fetchActiveBid(options).then(response => {
					if (response) {
						vm.bid = response
						vm.activeComponent = response

						vm.setComponentListFromBid()
						vm.$emit("bidSet",vm.bid)
					}
				})
			}
		}
	},
	created() {
		this.setBid()
	}
}
</script>